import { Grid } from '@material-ui/core';
import React from 'react';
import { Anchor, Header1, Step } from './blocks';
import { css } from '@emotion/react';

export default function Dropoff({ isDesktop, inProgress, before, after, order, callbacks, warehouse, readOnly }) {
    const isComplete = !!after?.pickup_date;

    const orderInProgress = order.order_status === 'inProgress';
    const hasDriver = !!warehouse?.driver;

    return (
        <Step
            isDesktop={isDesktop}
            isComplete={isComplete}
            inProgress={inProgress}
            label={() => {
                return (
                    <Grid
                        direction="row"
                        container
                        css={css`
                            align-items: center;
                        `}
                    >
                        <Grid
                            direction="column"
                            css={css`
                                margin-right: 8px;
                            `}
                        >
                            <Header1>In-transit</Header1>
                        </Grid>
                        {orderInProgress && hasDriver && !readOnly && (
                            <Grid
                                direction="column"
                                css={css`
                                    margin-right: 8px;
                                `}
                            >
                                <Anchor
                                    onClick={(e) => {
                                        callbacks.openDriverTracking(warehouse.driver);
                                    }}
                                >
                                    <Header1>Update Tracking</Header1>
                                </Anchor>
                            </Grid>
                        )}
                    </Grid>
                );
            }}
        >
            {() => <></>}
        </Step>
    );
}
